import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import c300 from "../../../../assets/info/300c-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import bush1 from "../../../../assets/info/chrysler-300c/300c-front-wishbone.jpg";
import bush2 from "../../../../assets/info/chrysler-300c/300c-rear-wishbone.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import styled from "styled-components";

const Chrysler300C = () => {
  useSmallNav("Chrysler 300C");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"CHRYSLER 300C"} bolder />
        <InfoHero image={c300} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Tajna formuła trwałych tulei uretanowych do Chryslera 300C"
              }
            />
            <p>
              Pedders Suspension przeprowadził obszerne badania i rozwijał swoją
              kompletną gamę produktów zawieszenia, dopasowaną do modelu
              Chrysler 300C, nazywanego również platformą LX. Dotyczy to
              Chryslera 300C, Dodge Charger’a i Dodge Magnum.
            </p>
            <p>
              Gama produktów Pedders Suspension do tych samochodów obejmuje
              sprężyny, amortyzatory i tuleje. Wiele z tych komponentów oferuje
              dłuższą żywotność i/lub wydajność w porównaniu z oryginalną
              ofertą. Niezależnie od tego, czy szukasz części zamiennych o
              dłuższej żywotności, czy też lepszych osiągów, zawieszenie Pedders
              ma rozwiązanie.
            </p>
            <p>
              Najczęstszymi awariami w 300C są tuleje amortyzatora, a zaraz za
              nimi plasują się tuleje dolnego amortyzatora. Pedders oferuje
              zamienniki o znacznie dłuższej żywotności i gwarancji trwałości!
            </p>
            <p>
              Nie wiesz, jaką tuleję zamówić? Sprawdź nasz diagram elementów
              zawieszenia przedniego 300C. Wszystkie tuleje dostarczane są w
              parach. Cena którą widzisz obejmuje tuleje na obie strony
              samochodu.
            </p>
            <p>
              Nie wiesz jak zamontować tuleje? W razie potrzeby do każdego
              pakietu tulei dołączona jest instrukcja.
            </p>
            <p>
              Szukasz poprawy prowadzenia swojego samochodu? Pedders ponownie
              oferuje gamę produktów, które pomogą Ci to osiągnąć. Czy to zestaw
              sprężyn obniżających dla lepszego wyglądu, czy kompletny zestaw
              zawieszenia gwintowanego!
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Chrysler 300c Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Chrysler 300c Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Chrysler")
              .models.find((e) => e.display === "Chrysler 300C")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Lokalizacja tulei przedniego zawieszenia Peddera"}
              />
              <div>
                <StyledImgParts
                  src={bush1}
                  alt="Lokalizacja tulei przedniego zawieszenia Peddera"
                />
              </div>
            </Gray>
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Lokalizacja tulei tylnego zawieszenia Peddera"}
              />
              <div>
                <StyledImgParts
                  src={bush2}
                  alt="Lokalizacja tulei tylnego zawieszenia Peddera"
                />
              </div>
            </Gray>
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Chrysler" model="300C" /> */}
      </Container>
    </section>
  );
};

export default Chrysler300C;

const StyledImgParts = styled.img`
  width: 100%;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
